import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Field, Select, Skeleton } from '@sixui/ui';

import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useWPPlaylistsQuery } from '~/lib/api/modules/WPPlaylists/hooks/useWPPlaylistsQuery';

export type IWPPlaylistSelectorProps = IOmit<ISelectProps, 'items'> & {
  appId: string;
};

export const WPPlaylistSelector = forwardRef<
  HTMLDivElement,
  IWPPlaylistSelectorProps
>(function WPPlaylistSelector(props, forwardedRef) {
  const { appId, ...other } = props;
  const wpPlaylistsQuery = useWPPlaylistsQuery({ appId }, { cacheTime: 0 });
  const items: Array<IFilterableListItem> =
    wpPlaylistsQuery.data?.map(({ title, permalink }) => ({
      value: permalink,
      label: title,
    })) ?? [];
  const loaded = !!wpPlaylistsQuery.data || !wpPlaylistsQuery.isLoading;

  return wpPlaylistsQuery.isError ? (
    <ErrorMessage error={wpPlaylistsQuery.error} />
  ) : loaded ? (
    <Select {...other} items={items} ref={forwardedRef} />
  ) : (
    <Skeleton>
      <Field />
    </Skeleton>
  );
});
